import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import { formatProviderName } from '../utils';

const ProviderCell = ({ providerData, withLink }) => {
  if (isEmpty(providerData)) {
    return '';
  }

  const providerPresentation = formatProviderName(providerData);

  if (withLink) {
    return (
      <a
        href={window.Routes.provider_path(providerData.id)}
        className="link"
        target="_blank"
      >
        { providerPresentation }
      </a>
    )
  } else {
    return providerPresentation;
  }
};

ProviderCell.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    npi: PropTypes.string,
  }),
  withLink: PropTypes.bool
};

ProviderCell.defaultProps = {
  provider: null,
  withLink: false
};

export default ProviderCell;
